'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class indicatorModel extends ngDepModel
{
		
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	
	getValue(name){
		switch(name){
			case 'created':
			case 'latest_date':
			case 'due_date':
			case 'date':
				if(this[name] == 0){
					return '';
				}
//				return this.s('$filter')('u2date')(this[name], 'dd/MM/y HH:mm (Z)');
				return this.s('$filter')('u2date')(this[name], 'dd/MM/y');
			case 'project_status':
				return this.getClassifValue(name, 'project_status');
			case 'unit':
			case 'unit_id':
				return this.getClassifValue('unit_id', 'unit');
			case 'pc':
				let val = 0.00;
				if(typeof(this.deliverable_quantity) !== undefined && !isNaN(this.deliverable_quantity) && typeof(this.total_value) !== undefined && !isNaN(this.total_value)){
					val =  Number(parseFloat((parseInt(this.total_value) / parseInt(this.deliverable_quantity)) * 100).toFixed(2));
				}
				return this.s('$filter')('suffix')(val, ' %');
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
	
}